import { Component, inject } from '@angular/core';
import { DatabaseModelService } from '../../services/database-model/database-model.service';
import { map, Observable, switchMap, take } from 'rxjs';
import { DatabaseModel } from '../../models/class/database-model.class';
import { DisplayModelApiService } from '../../services/display-model-api/display-model-api.service';
import { DisplayModelDto } from '../../models/display/display-model.dto';
import { AsyncPipe } from '@angular/common';
import { DatabaseModelBuilder } from '../../models/builder/database-model-builder.class';
import { SavedDatabaseModel } from '../../models/saved/saved-database-model.type';
import { ModelCanvasComponent } from '../../components/canvas/model-canvas/model-canvas.component';
import { ToolbarComponent } from '../../../../core/components/toolbar/components/toolbar.component';
import { ToolbarAction } from '../../../sequence-diagram-page/types/toolbarAction.types';
import { EXPORT_PNG_ICON_SVG } from '../../../../core/components/toolbar/svg/svg-toolbar.constant';
import { ExportPngService } from '../../../../core/services/export-png/export-png.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-display-model',
  standalone: true,
  imports: [AsyncPipe, ModelCanvasComponent, ToolbarComponent],
  templateUrl: './display-model.component.html',
  styleUrl: './display-model.component.scss',
})
export class DisplayModelComponent {
  private _databaseModelService = inject(DatabaseModelService);
  private _displayModelApi = inject(DisplayModelApiService);
  private _exportPngService = inject(ExportPngService);
  private _toastr = inject(ToastrService);

  model$: Observable<DatabaseModel> = this._databaseModelService.getModel$();
  displayModel$: Observable<DisplayModelDto> = this.getDisplayModel$();

  toolbarActions: ToolbarAction[] = [
    {
      label: 'Exporter en PNG',
      ariaLabel: 'Exporter le modèle en PNG',
      svg: EXPORT_PNG_ICON_SVG,
      action: () => this.handleExportPng(),
    },
  ];

  handleExportPng(): void {
    const canvas = document.querySelector('app-model-canvas canvas') as HTMLCanvasElement;

    if (!canvas) {
      this._toastr.error(`Impossible d'exporter le modèle.`);
      return;
    }

    this.model$.pipe(take(1)).subscribe(model => {
      try {
        this._exportPngService.exportCanvas(canvas, {
          filename: model.getTitle() || 'database-model',
        });

        this._toastr.success(`"${model.getTitle()}" exporté avec succès.`);
      } catch {
        this._toastr.error(`Erreur lors de l'export PNG du modèle.`);
      }
    });
  }

  getDisplayModel$(): Observable<DisplayModelDto> {
    return this.model$.pipe(
      map((model: DatabaseModel) => DatabaseModelBuilder.buildToSaved(model)),
      switchMap((model: SavedDatabaseModel) => this._displayModelApi.post$(model))
    );
  }
}
